import CONSTANTS, { Region, Environments, CLOUDFRONT_HOSTNAMES } from "./Constants";

export function getRegion(): string {
  return Region.US_WEST_2;
}

/**
 * Function that will return true if the hostname has a certain domain. Else returns false.
 *
 * @returns boolean
 */
export function isHostNativeAWSWebsite() {
  return RegExp(/(aws\.dev|a2z\.org\.cn)/).test(window.location.hostname);
}

export const getEnvironment = () => {
  const browserUrl = window.location.href;
  if (browserUrl.includes("localhost")) {
    return Environments.LOCAL;
  } else if (
    browserUrl.includes(CONSTANTS.ALPHA_HOSTNAME) ||
    browserUrl.includes(CLOUDFRONT_HOSTNAMES.ALPHA)
  ) {
    return Environments.ALPHA;
  } else if (
    browserUrl.includes(CONSTANTS.BETA_HOSTNAME) ||
    browserUrl.includes(CLOUDFRONT_HOSTNAMES.BETA)
  ) {
    return Environments.BETA;
  } else if (
    browserUrl.includes(CONSTANTS.PREPROD_HOSTNAME) ||
    browserUrl.includes(CLOUDFRONT_HOSTNAMES.GAMMA)
  ) {
    return Environments.GAMMA;
  } else if (
    browserUrl.includes(CONSTANTS.PROD_HOSTNAME) ||
    browserUrl.includes(CLOUDFRONT_HOSTNAMES.PROD)
  ) {
    return Environments.PROD;
  } else {
    return Environments.BETA;
  }
};

export const isDevEnvironment = () => {
  return [Environments.LOCAL, Environments.ALPHA, Environments.BETA].includes(getEnvironment());
};

export const isPreProdEnvironment = () => {
  return getEnvironment() !== Environments.PROD;
};
